<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>商城{{ id > 0 ? '编辑' : '新增' }}</span>
        </div>
        <el-form ref="formData" :rules="rules" :model="formData" label-width="150px">
          <el-form-item :label="id >0 ?'类型':'商品ID'" prop="gtype">
            <el-form :inline="true">
              <el-form-item v-if="id <= 0" prop="gid" style="margin-left: 10px">
                <el-input v-model.number="formData.gid" style="width: 250px" placeholder="商品ID" />
              </el-form-item>
              <el-form-item>
                <el-select v-model.number="formData.gtype" style="width: 250px" placeholder="请选择" @change="changeType">
                  <el-option
                    v-for="(item, index) in shopType"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>

              <el-form-item label="渠道" prop="gchannel" style="margin-left: 10px">
                <el-select v-model.number="formData.gchannel" style="width: 250px" placeholder="请选择">
                  <el-option
                    v-for="(item, index) in shopChannel"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>

              <el-form-item label="状态" prop="status">
                <el-select v-model.number="formData.gstatus" style="width: 250px" placeholder="请选择">
                  <el-option
                    v-for="(item, index) in statusType"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-form>

          </el-form-item>

          <el-form-item label="商品名称" prop="gname">
            <el-form :inline="true">
              <el-input v-model.trim="formData.gname" style="width: 250px" placeholder="商品名称" />

              <el-form-item label="商品名称(多语言KEY)" prop="gname_en" style="margin-left: 10px">
                <el-input v-model.trim="formData.gname_en" style="width: 250px" placeholder="商品名称(多语言KEY)" />
              </el-form-item>

              <el-form-item label="商品描述(多语言KEY)" prop="gdesc_en" style="margin-left: 10px">
                <el-input v-model.trim="formData.gdesc_en" style="width: 250px" placeholder="商品描述(多语言KEY)" />
              </el-form-item>
            </el-form>
          </el-form-item>

          <el-form-item :label="!isDiscount.includes(formData.gtype) ? '价格' : coinsBuy.includes(formData.gtype) ? '购买金币' : '' " prop="gname">
            <el-form :inline="true">
              <el-form-item v-if="!isDiscount.includes(formData.gtype)">
                <el-select v-model.number="formData.gprice" style="width: 250px" placeholder="请选择" @change="(v)=>priceChange(v)">
                  <el-option
                    v-for="(item, index) in shopSku"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item v-if="!isDiscount.includes(formData.gtype)" label="商品折扣" prop="gdiscount" style="margin-left: 10px">
                <el-input v-model.trim="formData.gdiscount" style="width: 250px" placeholder="商品折扣" />
              </el-form-item>
              <el-form-item v-if="!isDiscount.includes(formData.gtype)" label="原价SKU" prop="origPriceSku" style="margin-left: 10px">
                <el-select v-model="formData.origPriceSku" clearable style="width: 200px;" placeholder="请选择">
                  <el-option
                    v-for="item in origPriceSkuSelect"
                    :key="item.sku"
                    :label="item.label"
                    :value="item.sku"
                  />
                </el-select>
              </el-form-item>
              <el-form-item v-if="coinsBuy.includes(formData.gtype)" prop="gprice" style="margin-left: 10px">
                <el-input v-model.trim="formData.gprice" style="width: 250px" placeholder="购买金币" />
              </el-form-item>
              <el-form-item v-if="isCard(formData.gtype)" label="sku" prop="gsku" style="margin-left: 10px">
                <el-select v-model="formData.gsku" style="width: 250px" placeholder="请选择">
                  <el-option
                    v-for="(item, index) in card"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-form>
          </el-form-item>

          <el-form-item :label="isTextList.includes(formData.gtype) ? '数量' : ''">
            <el-form :inline="true">
              <!--              <el-input v-if="isTextList.includes(formData.gtype)" v-model.number="formData.gbaseReward" style="width: 250px" placeholder="数量" />-->

              <el-form-item v-if="isTextList.includes(formData.gtype)" style="margin-left: 10px" label="基础数量" prop="gbaseReward">
                <el-input v-model.number="formData.gbaseReward" style="width: 250px;" placeholder="基础数量" />
              </el-form-item>

              <el-form-item v-if="isTextList.includes(formData.gtype)" style="margin-left: 10px" label="首购赠送数量" prop="gfirstPurchase">
                <el-input v-model.number="formData.gfirstPurchase" style="width: 250px;" placeholder="首购赠送数量" />
              </el-form-item>
            </el-form>
          </el-form-item>

          <el-form-item label="限购数量(0:不限购)" prop="gMax" style="margin-left: 10px">
            <el-input v-model.number="formData.gMax" style="width: 250px" placeholder="限购数量" />
          </el-form-item>

          <el-form-item v-if="firstGift.includes(formData.gtype)" style="margin-left: 10px" label="礼品配置">
            <el-card>
              <el-row v-for="(item, index) in formData.gbaseReward" :key="index">
                <el-form :inline="true" style="margin-top: 8px">
                  <el-select v-model.number="item.propsId" style="width: 250px" placeholder="请选择">
                    <el-option
                      v-for="(item, index) in rewardType"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>

                  <el-form-item label="数量" prop="num" style="margin-left: 10px">
                    <el-input v-model.number="item.num" style="width: 250px" placeholder="商品描述(多语言KEY)" />
                  </el-form-item>

                  <el-form-item>
                    <el-button type="danger" @click="removeBaseReward(index)">删除</el-button>
                  </el-form-item>
                </el-form>
              </el-row>
              <el-button style="margin-top: 8px" type="primary" @click="addBaseReward()">+</el-button>
            </el-card>
          </el-form-item>

          <el-form-item v-if="formData.gtype === 27" style="margin-left: 10px" label="礼品配置">
            <el-card>
              <el-form :inline="true" style="margin-top: 8px">
                <el-form-item label="类型" prop="bet" style="margin-left: 10px">
                  <el-select v-model.number="formData.gbaseReward.coins.coins" style="width: 250px" placeholder="请选择">
                    <el-option
                      v-for="(item, index) in coinsType1"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="倍数" prop="bet" style="margin-left: 10px">
                  <el-input v-model.number="formData.gbaseReward.coins.bet" style="width: 250px" placeholder="数量" />
                </el-form-item>
                <el-form-item label="体力" prop="spins" style="margin-left: 10px">
                  <el-input v-model.number="formData.gbaseReward.spins" style="width: 250px" placeholder="体力" />
                </el-form-item>
              </el-form>
              <el-form-item>
                <el-row v-for="(item, index) in formData.gbaseReward.props" :key="index">
                  <el-form :inline="true" style="margin-top: 8px">
                    <el-form-item label="道具" prop="num" style="margin-left: 10px">
                      <el-select v-model.number="item.propsId" style="width: 250px" placeholder="请选择">
                        <el-option
                          v-for="(item, index) in rewardType"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="数量" prop="num" style="margin-left: 10px">
                      <el-input v-model.number="item.num" style="width: 250px" placeholder="商品描述(多语言KEY)" />
                    </el-form-item>

                    <el-form-item>
                      <el-button type="danger" @click="removeBaseReward19(index)">删除</el-button>
                    </el-form-item>
                  </el-form>
                </el-row>
                <el-button style="margin-top: 8px" type="primary" @click="addBaseReward19()">+</el-button>
              </el-form-item>
            </el-card>
          </el-form-item>

          <el-form-item v-if="formData.gtype === 19" style="margin-left: 10px" label="奖励配置">
            <el-card>
              <el-form :inline="true" style="margin-top: 8px">
                <el-form-item label="金币类型" prop="bet" style="margin-left: 10px">
                  <el-select v-model.number="formData.gbaseReward.coins.coins" style="width: 250px" placeholder="请选择">
                    <el-option
                      v-for="(item, index) in coinsType"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="倍数" prop="bet" style="margin-left: 10px">
                  <el-input v-model.number="formData.gbaseReward.coins.bet" style="width: 250px" placeholder="数量" />
                </el-form-item>
              </el-form>

              <el-form :inline="true" style="margin-top: 8px">
                <el-form-item label="体力类型" prop="bet" style="margin-left: 10px">
                  <el-select v-model.number="formData.gbaseReward.spins.spins" style="width: 250px" placeholder="请选择">
                    <el-option
                      v-for="(item, index) in spinType"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="倍数" prop="bet" style="margin-left: 10px">
                  <el-input v-model.number="formData.gbaseReward.spins.bet" style="width: 250px" placeholder="数量" />
                </el-form-item>
              </el-form>
            </el-card>
          </el-form-item>

          <el-form-item label="排序" prop="gsort">
            <el-form :inline="true">
              <el-input v-model.number="formData.gsort" style="width: 250px" placeholder="排序" />
              <el-form-item label="支付渠道排序" prop="gchannel_sort" style="margin-left: 10px">
                <el-input v-model.number="formData.gchannel_sort" style="width: 250px" placeholder="支付渠道排序" />
              </el-form-item>
            </el-form>
          </el-form-item>

          <el-form-item label="状态" prop="gattribute">
            <el-form :inline="true">
              <el-select v-model.number="formData.gattribute" style="width: 250px" placeholder="请选择">
                <el-option
                  v-for="(item, index) in attributeArr"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <el-form-item label="所属平台" prop="gplatform" style="margin-left: 10px">
                <el-select v-model.number="formData.gplatform" style="width: 250px" placeholder="请选择">
                  <el-option
                    v-for="(item, index) in shopPlatForm"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>

              <el-form-item label="是否热门" prop="ghot" style="margin-left: 10px">
                <el-select v-model.number="formData.ghot" style="width: 250px" placeholder="请选择">
                  <el-option
                    v-for="(item, index) in shopHot"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-form>
          </el-form-item>
          <el-form-item label="商品图片名称" prop="gimg">
            <el-input v-model.number="formData.gimg" style="width: 400px" placeholder="商品图片名称" />
          </el-form-item>
          <el-form-item label="商品有效期" prop="gExpire">
            <el-input v-model.number="formData.gExpire" style="width: 400px" placeholder="商品有效期" />
          </el-form-item>
          <el-form-item label="首次加赠比例" prop="gfirstChargeAddPro">
            <el-input v-model="formData.gfirstChargeAddPro" style="width: 400px" placeholder="首次加赠比例" />
          </el-form-item>
          <el-form-item label="赠送比例" prop="gaddRatio">
            <el-input v-model="formData.gaddRatio" style="width: 400px" placeholder="赠送比例" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">保存</el-button>
            <el-button>取消</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getRewardType } from '@/api/config/slot'
import { getShopGoodsList, getShopType, getSku, updateShopGoodsCfg } from '@/api/config/shop-cfg'

export default {
  name: 'ShopGoodsEdit',
  data() {
    return {
      rewardType: [],
      statusType: [
        { label: '上架', value: 1 },
        { label: '下架', value: 2 }
      ],
      selectType: [
        {
          'id': 1,
          'title': '只取数量'
        },
        {
          'id': 2,
          'title': '等级取值'
        }
      ],
      loading: false,
      gtype: 0,
      id: 0,
      shopType: [],
      shopSku: [],
      nomalGoodsList: [1, 2, 109, 8, 24, 25, 15, 6, 17, 19, 20, 27],
      cardList: [3], // 宝箱
      isTextList: [3, 8, 6, 15], // 数量是 text 不是 json
      isDiscount: [3, 22, 107], // 是否有折扣
      coinsBuy: [3], // 金币购买的
      firstGift: [109],
      coinsType1: [
        { label: 'coin1', value: 'coin1' },
        { label: 'coin2', value: 'coin2' },
        { label: 'coin3', value: 'coin3' },
        { label: 'coin4', value: 'coin4' },
        { label: 'coin5', value: 'coin5' },
        { label: 'coin6', value: 'coin6' }
      ],
      coinsType: [
        { label: 'money1', value: 'money1' },
        { label: 'money2', value: 'money2' },
        { label: 'money2', value: 'money2' },
        { label: 'money4', value: 'money4' },
        { label: 'money5', value: 'money5' },
        { label: 'money5', value: 'money6' }
      ],
      spinType: [
        { label: 'spins1', value: 'spins1' },
        { label: 'spins2', value: 'spins2' },
        { label: 'spins3', value: 'spins3' },
        { label: 'spins4', value: 'spins4' },
        { label: 'spins5', value: 'spins5' },
        { label: 'spins6', value: 'spins6' }
      ],
      shopChannel: [{ label: 'GooglePlay', value: 1 }],
      shopPlatForm: [{ label: '全部', value: 0 }, { label: '安卓', value: 1 }, { label: 'IOS', value: 2 }],
      shopHot: [{ label: '是', value: 1 }, { label: '否', value: 0 }],
      attributeArr: [
        { label: '新品', value: 1 },
        { label: '热卖', value: 2 },
        { label: '其他', value: 3 }
      ],
      card: [
        { label: '木质宝箱', value: 'woodenChest' },
        { label: '黄金宝箱', value: 'goldenChest' },
        { label: '魔幻宝箱', value: 'magicalChest' }
      ],
      formData:
        {
          'id': 0,
          'gpid': 1,
          'gprice': 0.99,
          'gname': '',
          'gname_en': '',
          'gdesc': '',
          'gdesc_en': '',
          'gtype': 1,
          'gsku': '',
          'gid': '',
          'goriginReward': '',
          'gbaseReward': '',
          'gdiscount': 0,
          'gfirstPurchase': 0,
          'gfirstChargeAddPro': 0,
          'gchannel': 1,
          'gsort': 0,
          'gchannel_sort': 0,
          'gstatus': 1,
          'gattribute': 1,
          'ggameid': 1,
          'gplatform': 1,
          'gimg': '',
          'gaddRatio': 0,
          'ghot': 0,
          'gMax': 0,
          'gExpire': 0,
          'gShowCountry': '',
          'ext': [],
          'gShowGroup': []
        },
      rules: {},
      origPriceSkuSelect: []
    }
  },
  created() {
    const id = this.$route.query.id
    this.gtype = this.$route.query.type
    this.getShopTypeList()
    this.getSkuList(this.gtype)
    if (id > 0) {
      this.id = id
      this.getTables(id)
    }
    this.getRewardTypeData()
    console.log(1)
  },
  methods: {
    getTables(id) {
      getShopGoodsList({ id: id }).then(res => {
        if (res.code === 200) {
          this.formData = res.data.list[0]
        } else {
          this.msgError(res.msg)
        }
      })
    }, onSubmit() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          if (this.formData.gname === '') {
            this.msgError('商品名称不能为空')
            return
          }
          if (this.formData.gname_en === '') {
            this.msgError('商品名称(多语言)不能为空')
            return
          }
          if (this.formData.gdesc_en === '') {
            this.msgError('商品描述(多语言)不能为空')
            return
          }
          this.formData.g_type = this.gtype
          this.formData.gfirstChargeAddPro = parseFloat(this.formData.gfirstChargeAddPro)
          const data = JSON.stringify(this.formData)
          console.log('data', data)
          updateShopGoodsCfg({ data: data }).then(res => {
            if (res.code === 200) {
              this.msgSuccess(res.msg)
              this.$router.push({ path: '/config/shop-goods/index' })
            } else {
              this.msgError(res.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getSkuList(type = 1) {
      if (type > 2) {
        type = 3
      }

      if (type === 15) {
        type = 1
      }
      getSku({ type: type }).then(res => {
        if (res.code === 200) {
          this.shopSku = []
          this.origPriceSkuSelect = []
          this.origPriceSkuSelect.push({ label: '原价', value: '原价', sku: '' })
          this.origPriceSkuSelect.push({ label: '客户端计算', value: '客户端计算', sku: '1' })
          res.data.forEach((item) => {
            this.shopSku.push({ label: item.price, value: item.price, sku: item.sku })
            this.origPriceSkuSelect.push({ label: item.price, value: item.price, sku: item.sku })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getShopTypeList() {
      getShopType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            const val = res.data[i]
            this.shopType.push({ label: val, value: parseInt(i) })
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    addBaseReward() {
      this.formData.gbaseReward.push({
        propsId: 1,
        num: 0
      })
    },
    addBaseReward19() {
      this.formData.gbaseReward.props.push({
        propsId: 1,
        num: 0
      })
    },
    removeBaseReward19(i) {
      this.formData.gbaseReward.props = this.formData.gbaseReward.props.filter((item, key) => {
        return i !== key
      })
    },
    removeBaseReward(i) {
      this.formData.gbaseReward = this.formData.gbaseReward.filter((item, key) => {
        return i !== key
      })
    },
    priceChange(v) {
      // if (this.formData.gtype === 1 || this.formData.gtype === 2) {
      let sku = ''
      this.shopSku.forEach((item) => {
        if (item.value === v) {
          sku = item.sku
        }
      })
      console.log('sku', sku)
      this.formData.gsku = sku
      // }
    },
    changeType(v) {
      this.getSkuList(v)
      const val = parseInt(v)
      switch (val) {
        case 109:
          this.formData.goriginReward = 0
          this.formData.gbaseReward = [{ 'propsId': 14, 'num': 16000000 }]
          this.formData.gsku = this.shopSku[0].sku
          break
        case 19:
          this.formData.goriginReward = []
          this.formData.gbaseReward = {
            'coins': { 'coins': 'money1', 'bet': 1 }, 'spins': { 'spins': 'spins1', 'bet': 1 }
          }
          this.formData.gsku = this.shopSku[0].sku
          break
        case 27:
          this.formData.goriginReward = []
          this.formData.gbaseReward = {
            'coins': { 'coins': 'money1', 'bet': 5 }, 'spins': 100, 'props': [{ 'propsId': 9, 'num': 2 }]
          }
          this.formData.gsku = this.shopSku[0].sku
          break
        case 3:
          this.formData.gsku = this.card[0].value
          this.formData.gprice = 0
          break

        case 22:
        case 28:
        case 29:
        case 30:
        case 31:
        case 32:
        case 33:
        case 34:
        case 101:
        case 102:
        case 103:
        case 104:
        case 105:
        case 106:
        case 107:
        case 108:
        case 111:
        case 112:
        case 115:
          this.formData.gsku = ''
          this.formData.gprice = 0
          break

        default:
          setTimeout(() => {
            this.formData.gsku = this.shopSku[0].sku
            this.formData.gprice = this.shopSku[0].value
          }, 1000)

          this.formData.goriginReward = 0
          this.formData.gbaseReward = 0
          break
      }
    },
    nomalGoods(type) {
      if (this.nomalGoodsList.includes(type)) {
        return true
      }
      return false
    },
    isCard(type) {
      if (this.cardList.includes(type)) {
        return true
      }
      return false
    }
  }
}
</script>

<style scoped>
</style>
